export default __webpack_public_path__ + "static/char-list-pic-01-15036877f40faf644282d07bb51f4bc7.png";